export default __webpack_public_path__ + "static/support-a9921d66f222463f0154edaef918766c.jpg";